<template>
  <v-dialog v-model="isVisible" max-width="420px" persistent>
    <!-- <template v-slot:activator="{ on }">
      <v-btn fab dark small color="primary" v-on="on">
         <span style="position:absolute; left:-90px ; color:#000">add client</span>
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </template> -->
    <client-form :client="client" @close="closeDialog"></client-form>
  </v-dialog>
</template>

<script>
import clientForm from "../main/client/ClientForm";
export default {
  name: "ClientDialog",

  components: {
    clientForm
  },
  data: () => ({
    isVisible: false,
    client: {
      sendSMS: true
    }
  }),
  methods: {
    closeDialog() {
      this.resetForm();
      this.isVisible = false;
    },
    resetForm() {
      this.client = {
        name: "",
        description: "",
        sendSMS: true,
        phoneNumber: "",
        languageId: ""
      };
    }
  }
};
</script>

<style>
</style>